!function (e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r(require("react")) : "function" == typeof define && define.amd ? define(["react"], r) : "object" == typeof exports ? exports["react-render-in-browser"] = r(require("react")) : e["react-render-in-browser"] = r(e.react);
}(this, function (e) {
  return function (e) {
    var r = {};
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        enumerable: !0,
        get: n
      });
    }, t.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, t.t = function (e, r) {
      if (1 & r && (e = t(e)), 8 & r) return e;
      if (4 & r && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (t.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & r && "string" != typeof e) for (var o in e) t.d(n, o, function (r) {
        return e[r];
      }.bind(null, o));
      return n;
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, r) {
      return Object.prototype.hasOwnProperty.call(e, r);
    }, t.p = "", t(t.s = 6);
  }([function (e, r, t) {
    e.exports = t(3)();
  }, function (r, t) {
    r.exports = e;
  }, function (e, r, t) {
    "use strict";

    (function (e) {
      Object.defineProperty(r, "__esModule", {
        value: !0
      });
      var t = "undefined" != typeof window && void 0 !== window.document,
        n = void 0 !== e && null != e.versions && null != e.versions.node;
      r.isBrowser = t, r.isNode = n;
    }).call(this, t(5));
  }, function (e, r, t) {
    "use strict";

    var n = t(4);
    function o() {}
    e.exports = function () {
      function e(e, r, t, o, i, u) {
        if (u !== n) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }
      function r() {
        return e;
      }
      e.isRequired = e;
      var t = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: r,
        element: e,
        instanceOf: r,
        node: e,
        objectOf: r,
        oneOf: r,
        oneOfType: r,
        shape: r,
        exact: r
      };
      return t.checkPropTypes = o, t.PropTypes = t, t;
    };
  }, function (e, r, t) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, r) {
    var t,
      n,
      o = e.exports = {};
    function i() {
      throw new Error("setTimeout has not been defined");
    }
    function u() {
      throw new Error("clearTimeout has not been defined");
    }
    function c(e) {
      if (t === setTimeout) return setTimeout(e, 0);
      if ((t === i || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
      try {
        return t(e, 0);
      } catch (r) {
        try {
          return t.call(null, e, 0);
        } catch (r) {
          return t.call(this, e, 0);
        }
      }
    }
    !function () {
      try {
        t = "function" == typeof setTimeout ? setTimeout : i;
      } catch (e) {
        t = i;
      }
      try {
        n = "function" == typeof clearTimeout ? clearTimeout : u;
      } catch (e) {
        n = u;
      }
    }();
    var a,
      s = [],
      f = !1,
      l = -1;
    function p() {
      f && a && (f = !1, a.length ? s = a.concat(s) : l = -1, s.length && d());
    }
    function d() {
      if (!f) {
        var e = c(p);
        f = !0;
        for (var r = s.length; r;) {
          for (a = s, s = []; ++l < r;) a && a[l].run();
          l = -1, r = s.length;
        }
        a = null, f = !1, function (e) {
          if (n === clearTimeout) return clearTimeout(e);
          if ((n === u || !n) && clearTimeout) return n = clearTimeout, clearTimeout(e);
          try {
            n(e);
          } catch (r) {
            try {
              return n.call(null, e);
            } catch (r) {
              return n.call(this, e);
            }
          }
        }(e);
      }
    }
    function y(e, r) {
      this.fun = e, this.array = r;
    }
    function h() {}
    o.nextTick = function (e) {
      var r = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var t = 1; t < arguments.length; t++) r[t - 1] = arguments[t];
      s.push(new y(e, r)), 1 !== s.length || f || c(d);
    }, y.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, o.title = "browser", o.browser = !0, o.env = {}, o.argv = [], o.version = "", o.versions = {}, o.on = h, o.addListener = h, o.once = h, o.off = h, o.removeListener = h, o.removeAllListeners = h, o.emit = h, o.prependListener = h, o.prependOnceListener = h, o.listeners = function (e) {
      return [];
    }, o.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, o.cwd = function () {
      return "/";
    }, o.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, o.umask = function () {
      return 0;
    };
  }, function (e, r, t) {
    "use strict";

    t.r(r);
    var n = t(1),
      o = t(0),
      i = t.n(o),
      u = t(2),
      c = function () {
        var e = window.opr || {};
        return !!window.opr && !!e.addons || !!window.opera || navigator.userAgent.indexOf(" OPR/") >= 0;
      },
      a = function () {
        return !!document.documentMode;
      },
      s = c,
      f = function () {
        return "undefined" != typeof InstallTrigger;
      },
      l = function () {
        var e = window.safari || {};
        return /constructor/i.test(window.HTMLElement) || "[object SafariRemoteNotification]" === (!window.safari || void 0 !== e && e.pushNotification).toString();
      },
      p = a,
      d = function () {
        return !a() && !!window.StyleMedia;
      },
      y = function () {
        return !!window.chrome && !c();
      },
      h = function () {
        var e = (window.navigator || {}).userAgent;
        return !!e && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(e);
      };
    function b(e) {
      return (b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function w(e, r) {
      for (var t = 0; t < r.length; t++) {
        var n = r[t];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function m(e, r) {
      return !r || "object" !== b(r) && "function" != typeof r ? function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e) : r;
    }
    function v(e) {
      return (v = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function g(e, r) {
      return (g = Object.setPrototypeOf || function (e, r) {
        return e.__proto__ = r, e;
      })(e, r);
    }
    var O = function (e) {
      function r(e) {
        var t;
        return function (e, r) {
          if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
        }(this, r), (t = m(this, v(r).call(this, e))).currentBrowser = u.isBrowser ? r.getCurrentBrowser() : void 0, t;
      }
      var t, o, i;
      return function (e, r) {
        if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(r && r.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), r && g(e, r);
      }(r, n["Component"]), t = r, i = [{
        key: "getCurrentBrowser",
        value: function () {
          var e = [{
            name: "mobile",
            isCurrentBrowser: h()
          }, {
            name: "chrome",
            isCurrentBrowser: y()
          }, {
            name: "firefox",
            isCurrentBrowser: f()
          }, {
            name: "safari",
            isCurrentBrowser: l()
          }, {
            name: "opera",
            isCurrentBrowser: s()
          }, {
            name: "ie",
            isCurrentBrowser: p()
          }, {
            name: "edge",
            isCurrentBrowser: d()
          }].filter(function (e) {
            return !0 === e.isCurrentBrowser;
          });
          if (e.length && 1 === e.length) return e[0].name;
        }
      }], (o = [{
        key: "componentDidMount",
        value: function () {
          this.currentBrowser = r.getCurrentBrowser();
        }
      }, {
        key: "shouldRenderForBrowser",
        value: function () {
          var e = this.props,
            r = e.only,
            t = e.except,
            n = e.all,
            o = e.none;
          if (n) return !0;
          if (o) return !1;
          var i = [];
          for (var u in this.props) this.props.hasOwnProperty(u) && !0 === this.props[u] && i.push(u);
          return r ? i.includes(this.currentBrowser) : t ? !i.includes(this.currentBrowser) : i.includes(this.currentBrowser);
        }
      }, {
        key: "render",
        value: function () {
          var e = this.props.children;
          return this.shouldRenderForBrowser() ? e : null;
        }
      }]) && w(t.prototype, o), i && w(t, i), r;
    }();
    O.propTypes = {
      chrome: i.a.bool,
      firefox: i.a.bool,
      safari: i.a.bool,
      opera: i.a.bool,
      ie: i.a.bool,
      edge: i.a.bool,
      mobile: i.a.bool,
      except: i.a.bool,
      only: i.a.bool,
      all: i.a.bool,
      none: i.a.bool,
      children: i.a.node
    }, O.defaultProps = {
      chrome: !1,
      firefox: !1,
      safari: !1,
      opera: !1,
      ie: !1,
      edge: !1,
      mobile: !1,
      except: !1,
      only: !1,
      all: !1,
      none: !1
    };
    var T = O;
    t.d(r, "default", function () {
      return T;
    });
  }]);
});